import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { UncontrolledTooltip as Tooltip } from 'reactstrap';
import BoostModal from '../../../components/Budget/Boost/BoostModal';
import {
  fetchBudgets,
  fetchSplitTestDetails,
  fetchSplitTests,
  getBudgets,
  getSplitTests,
  updateSplitTestBudgets
} from '../../../redux/overview/overviewActions';
import { getVrrPreferences } from '../../../redux/settings/settingAction';
import { TBoostModalValues } from '../../../components/Budget/Boost/BoostModal/types';
import { TBoostModalContainer } from './types';

export const BoostModalContainer: React.FC<TBoostModalContainer> = ({
  isOpen,
  onCancelAction
}) => {
  const { t } = useTranslation();
  const dispatch: any = useDispatch();
  const accountBudgets = useSelector(getBudgets);
  const splitTestsList = useSelector(getSplitTests);
  const brandId = useSelector(getVrrPreferences)?.current_brand_id;
  const [currentSplitTestId, setCurrentSplitTestId] = useState<string>('all');

  useEffect(() => {
    if (brandId) {
      dispatch(fetchSplitTests({ brandId }));
      setCurrentSplitTestId('all');
    }
  }, [brandId]);

  useEffect(() => {
    if (brandId && isOpen) {
      if (currentSplitTestId === 'all') {
        dispatch(fetchBudgets({ brandId }));
      } else {
        dispatch(
          fetchSplitTestDetails({ brandId, splitTestId: currentSplitTestId })
        );
      }
    }
  }, [currentSplitTestId, isOpen]);

  const handleCancel = () => {
    if (onCancelAction) onCancelAction();
  };

  const handleUpdate = (updatedBudgetValues: TBoostModalValues) => {
    if (brandId && currentSplitTestId !== 'all') {
      dispatch(
        updateSplitTestBudgets({
          brandId,
          splitTestId: currentSplitTestId,
          updatedBudgetValues
        })
      );
    }
  };

  return (
    <>
      {splitTestsList && (
        <BoostModal
          isOpen={isOpen}
          apiData={accountBudgets}
          splitTestsList={splitTestsList}
          currentSplitTestId={currentSplitTestId}
          onCancel={handleCancel}
          updateBudgets={handleUpdate}
          setCurrentSplitTestId={setCurrentSplitTestId}
        />
      )}
      {accountBudgets && accountBudgets.status === 'rejected' && (
        <Tooltip
          id={`tooltipVrr-boostModalButton`}
          placement="left"
          target="boostModalButton"
          hideArrow
        >
          {t('components.budget.boost.boost_button_error')}
        </Tooltip>
      )}
    </>
  );
};

export default BoostModalContainer;
